import { Currency } from '@principle-theorem/accounting';
import {
  DepositPaymentMode,
  DepositStatus,
  type IDepositMetadata,
} from '@principle-theorem/principle-core/interfaces';
import { BaseFirestoreMock } from '@principle-theorem/shared';

export class DepositMetadataMock extends BaseFirestoreMock<IDepositMetadata> {
  status = DepositStatus.Required;
  amountCents = 100;
  currency: Currency = Currency.AUD;
  paymentMode = DepositPaymentMode.Charge;
}
